import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../../assets/logo/logo.jpg"

const MakingMindsNav = () => {
    return (
        <div>
            <nav className="bg-white  border-gray-200 dark:bg-gray-900">
                <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-4">
                    <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                        <img src={logo} className="h-8 mr-0" alt="logo" />
                        <span className="self-center text-2xl font-bold font-mfont dark:text-white">
                            Making Minds Technologies
                        </span>
                    </Link>
                    <div className="flex items-center space-x-2 rtl:space-x-reverse">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" className="mt-0.5">
                            <rect width="24" height="24" fill="white" />
                            <circle cx="12" cy="12" r="9" stroke="#000000" strokeLinejoin="round" />
                            <path d="M12 3C12 3 8.5 6 8.5 12C8.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M12 3C12 3 15.5 6 15.5 12C15.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M3 12H21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M19.5 7.5H4.5" stroke="#000000" strokeLinejoin="round" />
                            <g filter="url(#filter0_d_15_556)">
                                <path d="M19.5 16.5H4.5" stroke="#000000" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d_15_556" x="3.5" y="16" width="17" height="3" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="1" />
                                    <feGaussianBlur stdDeviation="0.5" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_556" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15_556" result="shape" />
                                </filter>
                            </defs>
                        </svg><a className="text-sm  text-mblack font-mfont dark:text-bmblack hover:underline">English</a>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default MakingMindsNav